import { Injectable, inject } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { CreateSalesOrderFormGroup } from './create-sales-order-form-group.interface';
import { SalesOrderLineFormGroup } from './sales-order-line-form-group.interface';
import { SalesOrderLineFormModel } from './sales-order-line-form.model';

export const SALES_ORDER_SHORT_DESCRIPTION_MAX_LENGTH = 512;

@Injectable()
export class CreateSalesOrderFormModel {
  private readonly formBuilder = inject(FormBuilder);

  public readonly fieldNames = {
    clientId: 'clientId',
    shortDescription: 'shortDescription',
    requestedDeliveryDate: 'requestedDeliveryDate',
    lines: 'lines',
  } as const;

  public readonly form: FormGroup<CreateSalesOrderFormGroup>;

  constructor() {
    const formBuilder = this.formBuilder;

    this.form = formBuilder.group<CreateSalesOrderFormGroup>({
      clientId: new FormControl<string | null>(null),
      shortDescription: new FormControl('', {
        nonNullable: true,
        validators: [Validators.maxLength(SALES_ORDER_SHORT_DESCRIPTION_MAX_LENGTH)],
      }),
      requestedDeliveryDate: new FormControl<string | null>(null),
      lines: formBuilder.array<FormGroup<SalesOrderLineFormGroup>>([]),
    });
  }

  public get lines(): FormArray<FormGroup<SalesOrderLineFormGroup>> {
    return this.form.controls.lines;
  }

  public addLine(defaults?: { unitOfMeasureId: number | null }): FormGroup<SalesOrderLineFormGroup> {
    const lineForm = SalesOrderLineFormModel.buildFormGroup(this.formBuilder);
    if (defaults?.unitOfMeasureId !== undefined) {
      lineForm.controls.unitOfMeasureId.setValue(defaults.unitOfMeasureId);
    }
    this.lines.push(lineForm);
    return lineForm;
  }

  public removeLine(index: number): void {
    this.lines.removeAt(index);
  }
}
